import {
	Box,
	Flex,
	Text,
	Stack,
	InputGroup,
	Input,
	InputRightElement,
	Button,
	ButtonGroup,
	createStandaloneToast,
} from '@chakra-ui/react';
import { UilTimes } from '@iconscout/react-unicons';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectCustomFonts } from '../../../redux/customFontsSlice';
import { scrollBarStyle } from '../../../utils/layoutConfig';
import { getAuthHeader } from '../../../utils/auth-token';

const saveSuccessToast = {
	title: `Fontes salvas com sucesso`,
	status: 'success',
	duration: 3000,
	isClosable: true,
	position: 'top',
};

function removeFont({ fontsProp, setFontsProp, i, index }) {
	const newFontsProp = JSON.parse(JSON.stringify(fontsProp));
	newFontsProp[i].weights.splice(index, 1);
	if (!newFontsProp[i].weights.length) {
		newFontsProp.splice(i, 1);
	}
	setFontsProp(newFontsProp);
}

function importFont({ inputValue, setImportError, fontsProp, setFontsProp, setInputValue }) {
	try {
		setImportError(false);
		if (!inputValue || inputValue.includes('ital@')) {
			setImportError(
				'Você está tentando importar uma fonta em itálico. Fontes em itálico são importadas automáticamente a partir da fonte Regular',
			);
			return;
		}
		const newFontsProp = JSON.parse(JSON.stringify(fontsProp));
		const urlParams = inputValue.split('?')[1];
		const fontFamilies = urlParams.split('&').filter((el) => el.includes('family='));
		for (var i = 0; i < fontFamilies.length; i++) {
			const fontFamily = fontFamilies[i].replace('family=', '');
			const splited = fontFamily.split(':');
			let fontName = splited[0].replace(/\+/g, ' ');
			let weights = [];
			const types = fontFamily.split('@')[0].split(':')[1].split(',');
			console.log(types);
			if (types.includes('ital')) {
				fontName = splited[0];
				const weightsWithItalic = splited[1].split('@')[1].split(';');
				weightsWithItalic.map((weight) => {
					const splittedWeight = weight.split(',');
					if (splittedWeight[0] == 1) {
						weights.push(`${splittedWeight[1]}i`);
					} else {
						weights.push(`${splittedWeight[1]}`);
					}
				});
			} else {
				fontName = splited[0];
				weights = splited[1].split('@')[1].split(';');
			}

			const duplicatedFont = newFontsProp.filter((el) => el.font == fontName);
			let mergeDuplicated = [];
			if (duplicatedFont.length) {
				const duplicatedWeights = duplicatedFont[0].weights.filter((value) => weights.includes(value));
				if (duplicatedWeights.length) {
					setImportError(
						'Você está tentando importar uma fonte duplicada:' +
							duplicatedFont[0].font +
							' ' +
							duplicatedWeights.join(','),
					);
					return;
				}
				mergeDuplicated = duplicatedFont.weights;
			}
			console.log(weights);
			const obj = {
				font: fontName,
				weights: weights.concat(mergeDuplicated),
			};
			newFontsProp.push(obj);
		}
		setInputValue('');
		setFontsProp(newFontsProp);
	} catch (e) {
		console.log(e);
		setImportError('Houve um erro ao importar a url, verifique a url e tente novamente');
	}
}

function onChangeHandler({ e, setInputValue }) {
	const value = e.target.value;
	setInputValue(value);
}

function weightDict(value) {
	const dict = {
		100: 'Thin',
		'100i': 'Italic Thin',
		200: 'Extra-light',
		'200i': 'Italic Extra-light',
		300: 'Light',
		'300i': 'Italic Light',
		400: 'Regular',
		'400i': 'Italic Regular',
		500: 'Medium',
		'500i': 'Italic Medium',
		600: 'Semi-bold',
		'600i': 'Italic Semi-bold',
		700: 'Bold',
		'700i': 'Italic Bold',
		800: 'Extra-bold',
		'800i': 'Italic Extra-bold',
		900: 'Black',
		'900i': 'Italic Black',
	};
	return dict[value] ? dict[value] : value;
}

const GlobalTypographyWM = ({ fonts, viewId }) => {
	const toast = createStandaloneToast();
	const dispatch = useDispatch();
	const [importError, setImportError] = React.useState();
	const [inputValue, setInputValue] = React.useState('');

	const [fontsProp, setFontsProp] = React.useState(fonts);

	React.useEffect(() => {
		setFontsProp(fonts);
	}, [fonts]);

	function saveFonts() {
		if (JSON.stringify(fonts) !== JSON.stringify(fontsProp)) {
			dispatch(selectCustomFonts(fontsProp));
			saveChangesToJson(fontsProp);
		}
		toast(saveSuccessToast);
	}

	function saveChangesToJson(customFonts) {
		fetch(`${process.env.REACT_APP_COMPILER_URL}/api/tachyons/sendJSON/${viewId}`, {
			method: 'POST',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
				...getAuthHeader(),
			},
			body: JSON.stringify({ customFonts }),
		});
	}

	return (
		<Box h={'400px'} overflow={'auto'} sx={scrollBarStyle} p={2}>
			<Box>
				<Flex direction={'row'} sx={{ gap: '2%' }} w={'100%'} flexWrap={'wrap'} overflow={'auto'}>
					{fontsProp &&
						fontsProp.map((fontObj, i) => (
							<Box
								key={'font-props-box-' + i}
								borderRadius={'6px'}
								mb={3}
								borderWidth={'1px'}
								flexBasis={'100%'}
								height={'fit-content'}
							>
								{fontObj.weights.map((weight, index) => (
									<Flex
										sx={{ 'svg:hover': { cursor: 'pointer' } }}
										justifyContent={'space-between'}
										borderWidth={`0px 0px ${index == fontObj.weights.length - 1 ? '0px' : '1px'} 0`}
										fontFamily={fontObj.font}
										px={3}
										py={2}
										key={'font-' + index}
										value={fontObj.font + weight}
									>
										{fontObj.font} {weightDict(weight)}
										{fontObj.font != 'sans-serif' && fontObj.font != 'Palatino' && fontObj.font != 'Calibri' && (
											<UilTimes onClick={() => removeFont({ fontsProp, setFontsProp, i, index })} />
										)}
									</Flex>
								))}
							</Box>
						))}
				</Flex>
				<InputGroup pt={3} width={'100%'}>
					<Input
						pl={3}
						pr={'calc(4px + 5.5rem)'}
						w="100%"
						value={inputValue}
						onChange={(e) => {
							onChangeHandler({ e, setInputValue });
						}}
						isInvalid={importError ? true : false}
						size={'md'}
						borderRadius={'8px'}
						placeholder={'ex:https://fonts.googleapis.com/css2?family=Rubik:wght@300;500'}
					/>
					<InputRightElement width="5.5rem" top={'auto'}>
						<Button
							size={'md'}
							sx={{
								fontWeight: 'normal',
								width: '100%',
								borderRadius: '0 8px 8px 0',
								border: '1px solid rgb(203, 213, 224)',
							}}
							onClick={(e) => importFont({ inputValue, setImportError, fontsProp, setFontsProp, setInputValue })}
						>
							Importar
						</Button>
					</InputRightElement>
				</InputGroup>
				{!!importError && (
					<Text color={'red'} size="xs">
						{importError}
					</Text>
				)}
				<ButtonGroup my={2} minH={'30px'} display="flex" justifyContent={'flex-end'}>
					<Button
						alignSelf={'flex-end'}
						px={3}
						py={3}
						h="32px"
						bg="yellow.500"
						color="white"
						onClick={(e) => saveFonts()}
					>
						Salvar
					</Button>
				</ButtonGroup>
			</Box>
		</Box>
	);
};

const GlobalTypography = React.memo(GlobalTypographyWM);

export default GlobalTypography;
